import { render, staticRenderFns } from "./ModalImportShipments.vue?vue&type=template&id=245529b8&lang=pug"
import script from "./ModalImportShipments.vue?vue&type=script&lang=js"
export * from "./ModalImportShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports